import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Chip,
  Grid,
  MenuItem,
} from '@mui/material';
import { Controls } from '../../../../components/controls/Controls';
import Modal from '../../../../components/Modal';
import Form from '../../../../components/useForm';

export default function AccuroAppointmentReasonConfigurationModal(props) {
  const {
    isOpen,
    handleClose,
    setting,
    handleSave,
    appointmentReasons,
  } = props;
  const [selectedAppointmentReasons, setSelectedAppointmentReasons] = useState([]);

  const getSelectedAppointmentReasons = (appointmentReasonIds) => {
    if (appointmentReasonIds.value[0] === '') {
      return [];
    }
    return appointmentReasons.filter(
      (appointmentReason) => appointmentReasonIds.value.includes(
        appointmentReason.reasonId.toString(),
      ),
    );
  };

  const handleSelectChange = (event) => {
    const selectedIds = event.target.value;
    const selectedReasons = appointmentReasons.filter(
      (reason) => selectedIds.includes(reason.reasonId.toString()),
    );
    setSelectedAppointmentReasons(selectedReasons);
  };

  const saveAppointmentReasonIds = async () => {
    const selectedIds = selectedAppointmentReasons.map(
      (reason) => reason.reasonId.toString(),
    );
    await handleSave(setting, selectedIds.join(','));
  };

  useEffect(() => {
    if (isOpen) {
      setSelectedAppointmentReasons(getSelectedAppointmentReasons(setting));
    }
  }, [setting, appointmentReasons, isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      size="sm"
      title="Appointment reason configuration"
    >
      <Form>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          rowSpacing={1}
        >
          <Controls.Select
            sx={{ minWidth: '200px', maxWidth: '400px' }}
            name="appointmentReason"
            label="Appointment reason"
            value={selectedAppointmentReasons.map(
              (reason) => reason.reasonId.toString(),
            )}
            onChange={handleSelectChange}
            multiple
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <em>None</em>;
              }
              return (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selectedAppointmentReasons?.map((appointmentReason) => (
                    <Chip
                      key={appointmentReason.reasonId}
                      label={appointmentReason.name}
                    />
                  ))}
                </Box>
              );
            }}
          >
            {appointmentReasons.length > 0 ? appointmentReasons.map((appointmentReason) => (
              <MenuItem
                key={appointmentReason.reasonId}
                value={appointmentReason.reasonId.toString()}
              >
                {appointmentReason.name}
              </MenuItem>
            )) : <em> No appointment reasons found</em>}
          </Controls.Select>
          <Controls.Button
            text="save"
            onClick={saveAppointmentReasonIds}
          />
        </Grid>
      </Form>
    </Modal>
  );
}

const settingShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});

AccuroAppointmentReasonConfigurationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  setting: settingShape.isRequired,
  handleSave: PropTypes.func.isRequired,
  appointmentReasons: PropTypes.arrayOf(PropTypes.shape({
    reasonId: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
};
